<template>
    <div class="form-group">
        <label :for="id.ID()" :class="{'sr-only': srOnly}">
            <slot name="label">{{ label + (error && errorMessage ? ` ${$t('dash-{s}', {'s': errorMessage})}` : '') }}</slot>
        </label>
        <input
            :id="id.ID()"
            :value="value"
            @input="emitIfCompleted($event.target.value)"
            class="form-control" 
            :class="{ 'is-invalid' : error }"
            type="date" 
            :disabled="disabled"
            :min="min"
            :max="max"
        />
    </div>
</template>

<script>
import id from "src/modules/uuid.js"

export default {
    props: {
        value: String,
        label: {
            type: String,
            required: true,
        },
        srOnly: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        min: String,
        max: String,
    },
    data() {
        return {
            id: new id()
        }
    },
    methods: {
        emitIfCompleted(value) {
            const parts = value.split('-')

            if (parts[0].length != 4 || parts[1].length != 2 || parts[2].length != 2) return false

            const year = Number(parts[0])
            const month = Number(parts[1])
            const date = Number(parts[2])
            
            if (1000 > year || year > 9999) return
            if (1 > month || month > 12) return
            if (1 > date || date > 31) return

            this.$emit('input', value)
        }
    }
}
</script>